module.exports = __webpack_public_path__ + "img/23_104.2897625c.png";